module.exports = "<app-layout>\r\n    <router-outlet></router-outlet>\r\n</app-layout>"